import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";

export const getIsReady = (state: ApplicationState) => {
    const { parameter } = state.pages.productList;

    return Boolean(parameter);
};

export const getIsBrandPage = (state: ApplicationState) => {
    const { filterQuery, parameter } = state.pages.productList;
    const brandId = parameter?.brandIds?.[0];

    return brandId ? !filterQuery?.includes(brandId) : false;
};

export const getIsCategoryPage = (state: ApplicationState) => {
    const { filterQuery, parameter } = state.pages.productList;
    const categoryId = parameter?.categoryId;

    return categoryId ? !filterQuery?.includes(categoryId) : false;
};

export const getIsSearchPage = (state: ApplicationState) => {
    return Boolean(getIsReady(state) && !getIsCategoryPage(state) && !getIsBrandPage(state));
};

export const getSearchQuery = (state: ApplicationState) => {
    const { parameter } = state.pages.productList;
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");

    if (!getIsSearchPage(state)) {
        return null;
    }

    return parameter?.search ? correctedQuery || parameter?.search : undefined;
};
